import { LayoutPrincipal } from '@/components/layout';
import { AdminActividadesPantalla } from '@/pages/AdminActividadesPantalla';
import { AdminDensidadesPantalla } from '@/pages/AdminDensidadesPantalla';
import { AdminFioriOperadoresPantalla } from '@/pages/AdminFioriOperadoresPantalla';
import { AdminLabPinPantalla } from '@/pages/AdminLabPinPantalla';
import { AdminMapeoRecetasPantalla } from '@/pages/AdminMapeoRecetasPantalla';
import { AdminUmbralesPantalla } from '@/pages/AdminUmbralesPantalla';
import { AdminUsuariosPantalla } from '@/pages/AdminUsuariosPantalla';
import { AnalisisBatchesPantalla } from '@/pages/AnalisisBatchesPantalla';
import { ColadaDetallePantalla } from '@/pages/ColadaDetallePantalla';
import { ColadasListaPantalla } from '@/pages/ColadasListaPantalla';
import { DashboardPantalla } from '@/pages/DashboardPantalla';
import { EsclerometroDetallePantalla } from '@/pages/EsclerometroDetallePantalla';
import { EsclerometroListaPantalla } from '@/pages/EsclerometroListaPantalla';
import { FioriLoginPantalla } from '@/pages/FioriLoginPantalla';
import { InformeMuestraPantalla } from '@/pages/InformeMuestraPantalla';
import { LabLoginPantalla } from '@/pages/LabLoginPantalla';
import { MuestraDetallePantalla } from '@/pages/MuestraDetallePantalla';
import { MuestrasListaPantalla } from '@/pages/MuestrasListaPantalla';
import { NoEncontradoPantalla } from '@/pages/NoEncontradoPantalla';
import { PedidosBcSolicitudesPantalla } from '@/pages/PedidosBcSolicitudesPantalla';
import { RegistrarColadaFioriPantalla } from '@/pages/RegistrarColadaFioriPantalla';
import { createBrowserRouter } from 'react-router-dom';

export const router = createBrowserRouter(
  [
    // Pantalla de login por PIN — top-level (sin layout, sin gate MSAL).
    // Pensada para usuarios de Laboratorio sin email corporativo. Después de
    // un login exitoso guarda el JWT en localStorage y redirige a
    // /lab/muestras (que sí pasa por LayoutPrincipal y respeta el rol).
    { path: '/lab-login', element: <LabLoginPantalla /> },
    // Igual que /lab-login, pero para operadores Fiori (cada uno con su
    // propio PIN — ver FioriLoginPantalla).
    { path: '/fiori-login', element: <FioriLoginPantalla /> },

    // Vista imprimible del informe de muestra: TOP-LEVEL (sin el header/nav
    // de LayoutPrincipal) para que salga una hoja limpia. Sigue protegida por
    // auth porque todo el router vive dentro de <AuthenticatedTemplate>.
    { path: '/lab/muestras/:id/informe', element: <InformeMuestraPantalla /> },
    {
      path: '/',
      element: <LayoutPrincipal />,
      children: [
        { index: true, element: <DashboardPantalla /> },
        { path: 'coladas', element: <ColadasListaPantalla /> },
        { path: 'coladas/registrar-fiori', element: <RegistrarColadaFioriPantalla /> },
        { path: 'coladas/:id', element: <ColadaDetallePantalla /> },
        { path: 'analisis-batches', element: <AnalisisBatchesPantalla /> },
        // Laboratorio. Backend valida rol Laboratorio/Admin en cada endpoint.
        // En el frontend ocultamos el link del header si el usuario no tiene rol.
        { path: 'lab/muestras', element: <MuestrasListaPantalla /> },
        { path: 'lab/muestras/:id', element: <MuestraDetallePantalla /> },
        { path: 'lab/esclerometro', element: <EsclerometroListaPantalla /> },
        { path: 'lab/esclerometro/:id', element: <EsclerometroDetallePantalla /> },
        // Pantalla admin. El backend valida el rol (devuelve 403 si no es Admin).
        // En el frontend además ocultamos el link del header para Operador/Laboratorio.
        { path: 'admin/usuarios', element: <AdminUsuariosPantalla /> },
        { path: 'admin/actividades', element: <AdminActividadesPantalla /> },
        { path: 'admin/umbrales', element: <AdminUmbralesPantalla /> },
        { path: 'admin/pedidos-bc', element: <PedidosBcSolicitudesPantalla /> },
        { path: 'admin/densidades', element: <AdminDensidadesPantalla /> },
        { path: 'admin/mapeo-recetas', element: <AdminMapeoRecetasPantalla /> },
        { path: 'admin/lab-pin', element: <AdminLabPinPantalla /> },
        { path: 'admin/fiori-operadores', element: <AdminFioriOperadoresPantalla /> },
        { path: '*', element: <NoEncontradoPantalla /> },
      ],
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
      v7_normalizeFormMethod: true,
      v7_partialHydration: true,
      v7_skipActionErrorRevalidation: true,
    },
  },
);
